import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ClientDashboardService } from 'src/app/client-dashboard/service/client-dashboard.service';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss'],
})
export class NotesComponent implements OnInit {
  @ViewChild('inputValue', { static: true }) inputValue;
  onDestroyNotifier$ = new Subject();
  title: string = '';
  content = '';
  message;
  messageRequired = false;

  constructor(
    public dialogRef: MatDialogRef<NotesComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private clientDashboardService: ClientDashboardService
  ) {}

  ngOnInit() {
    this.message = this.data?.inputValue.note;
  }

  deleteNotes() {
    let investorId = this.data?.investorId;
    this.clientDashboardService
      .deleteUserNotes(this.data?.inputValue._id)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.dialogRef.close();
      });
  }

  updateNotes() {
    if (!this.message) {
      this.messageRequired = true;
      return;
    }
    this.data.proceedAction(this.message, () => {});
  }
}
